export default "__VITE_ASSET__CKsMdO2z__"